























































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import CommonHeader from '@/app/components/Common/Header.vue'
import FieldSearch from '@/app/components/Field/FieldSearch.vue'
import FieldMap from '@/app/components/Field/FieldMap.vue'
import FieldList from '@/app/components/Field/FieldList.vue'
/* api */
import FieldListApi from '@/app/model/api/fieldListApi'
import FieldSortApi from '@/app/model/api/fieldSortApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
import AiAdviceApi from '@/app/model/api/aiAdviceApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import MapClass from '@/app/module/map'
import { routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    Loading,
    CommonHeader,
    FieldSearch,
    FieldMap,
    FieldList
  }
})
export default class Field extends Vue {
  private target: string = this.$store.state.fieldState.accordionType
  private isActive: boolean = false
  private isOpend: any = {}
  /* 表示切り替え */
  private showNotFound: boolean = false
  private showFieldListLoading: boolean = true
  private accordionOpenFlag: boolean = true
  private accordionChangeFlag: boolean = true
  private renderList: boolean = false
  /* データ */
  private accordionData: Array<{[key:string]: string|number}> = []
  private displayAccordionData: Array<{[key:string]: string|number}> = []
  private accordionList: Array<{[key:string]: string}> = []
  public mapData: Array<{[key:string]: any}> = []
  private mapList: Array<{[key:string]: any}> = []
  private fieldList: Array<{[key:string]: any}> = []
  private displayFieldList: Array<{[key:string]: any}> = []
  private fieldDetailsData: any[] = []
  private errorMessage: string = ''
  private totalFieldCount: number = 0
  private accordionFlag: boolean = true
  private changeListData: boolean = true
  private count: any = []
  private sortOrder: string = this.$store.state.fieldState.sortOrder
  private sort: string = this.$store.state.fieldState.sort
  private sortOrderSelected: any = [
    { text: '収穫適期までの日数', value: 'harvestForecastDays' },
    { text: '積算温度', value: 'integrationTemperature' },
    { text: '圃場名', value: 'fieldName' }
  ]
  private sortSelected: any = [
    { text: '昇順', value: 'asc' },
    { text: '降順', value: 'desc' }
  ]

  private get sortChange (): any {
    return [this.sortOrder, this.sort]
  }

  @Watch('sortChange')
  getSortChange () {
    if (this.fieldList.length !== 0) {
      this.showFieldListLoading = true

      this.changeSort()
      this.$store.commit('fieldState/setSortOrder', this.sortOrder)
      this.$store.commit('fieldState/setSort', this.sort)
      this.$store.commit('fieldState/setFieldSortFlag', false)
    }
  }

  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.id
  }
  @Watch('fieldChoiceState')
  private onIdChange (newValue: string) {
    if (newValue !== '') {
      this.$router.push('#' + newValue).catch(e => {})
    }
  }
  @Watch('$route')
  private onRouteChange (to: {[key:string]: string}) {
    if (to.hash) {
      let el: any = document.getElementById(to.hash.replace(/^#/, ''))

      if (el !== null && el !== undefined) {
        let acoordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = acoordionId.indexOf('/')
        let id = acoordionId.slice(index + 1)

        this.openSpecificAccordion(id)

        if (el && this.$store.state.fieldChoiceState.isScroll) {
          el.scrollIntoView({ behavior: 'instant' })
        } else {
          this.$store.commit('fieldChoiceState/setIsScroll', true)
        }
      }
    }
  }
  created () {
    /* 検索結果を保持しているかどうか判定 */
    let stateData = this.$store.state.fieldState

    // 検索値が全て初期状態だったらlistApiをそのまま叩く処理
    if (stateData.fieldSearchStatus === 0 &&
        stateData.fieldSearchVariety === '' &&
        stateData.fieldSearchRisk === 0 &&
        stateData.fieldSearchText === '' &&
        stateData.accordionType === '1') {
      this.getFieldData(false)
    } else {
      this.doSearch(true)
    }
  }

  /* データ取得 */
  // resetFlag=trueの場合はリセット、flaseの場合は初期取得
  private async getFieldData (resetFlag: boolean) {
    this.showFieldListLoading = true
    this.renderList = false
    let search: any = this.$refs.search
    if (search !== undefined) {
      search.requesting = true
    }

    /* ページの一番上を表示 */
    this.isActive = true
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    const result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly, '0', {})

    if (result.isOk()) {
      /* 品種絞り込みのデータ */
      Local.setVarietiesData(JSON.stringify(result.getPayload().varieties))
      Local.setGrowthStageData(JSON.stringify(result.getPayload().growth_stage))
      Local.setRiskData(JSON.stringify(result.getPayload().risk))

      /* 圃場件数 */
      this.totalFieldCount = result.getPayload().total_field_count

      /* データ追加フラグ更新 */
      this.$store.commit('setFlagState/setSelectDataListFlag', true)
      this.$store.commit('setFlagState/setMySelectDataListFlag', true)

      /* マップのデータを作成 */
      if (result.getPayload().polygon_list.length !== 0) {
        // 作付けなしを一番下に配置
        const sortAccodionList = result.getPayload().accordion_list
        const index = sortAccodionList.findIndex((n: any) => n.accordion_name === '')
        if (index !== -1) {
          const x: any = sortAccodionList.splice(index, 1)
          sortAccodionList.push(x[0])
        }
        this.accordionData = sortAccodionList
        this.accordionList = sortAccodionList

        // リセット
        this.mapList = Array(result.getPayload().polygon_list.length)
        this.fieldList = Array(result.getPayload().polygon_list.length)

        // データ取得できたら描画
        this.renderList = true

        /* エリアごとに詳細を取得 */
        this.count = []
        for (var k in result.getPayload().accordion_list) {
          let accordionData = result.getPayload().accordion_list[k]
          this.getFieldDetailsData(accordionData.accordion_id, true)
        }

        /* マップデータ作成 */
        for (var j in result.getPayload().polygon_list) {
          this.createDataList(result.getPayload().polygon_list[j], parseInt(j))

          /* エリアデータをlocalstorageに保存 */
          let accordionData = result.getPayload().polygon_list[j]
          accordionData['timestamp'] = Date.now()

          // リセットボタン押下の時
          if (resetFlag) {
            /* アコーディオンを一度すべて閉じる */
            for (var i in this.accordionList) {
              let id = this.accordionList[i].accordion_id
              this.$set(this.isOpend, id, false)
              this.accordionFlag = false
            }

            // 選択している圃場のリセット
            this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
            this.$router.push('field').catch(e => {})
          }
        }
        this.mapCreate()
        this.isActive = false

        if (search !== undefined) {
          search.requesting = false
        }
      } else {
        this.showFieldListLoading = false
        this.showNotFound = true

        if (search !== undefined) {
          search.requesting = false
        }
      }
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      this.showFieldListLoading = false
    }
  }

  /* 取得したデータからリストを作成 */
  private createDataList (result: any, key: number) {
    /* マップのデータを作成 */
    const mapData: any = {
      id: result.polygon_field_id,
      path: result.polygon,
      strokeColor: result.polygon_color,
      fillColor: result.polygon_frame_color,
      fieldComSensor: MapClass.getSensorLatLng('field_cam_sensor', result.field_cam_sensor),
      canonSensor: MapClass.getSensorLatLng('canon_sensor', result.canon_sensor),
      fieldServerSensor: MapClass.getSensorLatLng('field_server_sensor', result.field_server_sensor),
      paddyWatchSensor: MapClass.getSensorLatLng('paddy_watch_sensor', result.paddy_watch_sensor)
    }

    const fieldData: any = {
      fieldName: result.polygon_field_name,
      fieldId: result.polygon_field_id,
      plantingId: result.polygon_planting_id,
      accordionId: result.accordion_id
    }

    if (result.polygon.length === 0) {
      mapData.fieldPosition = {
        lat: parseFloat(result.field_lat),
        lng: parseFloat(result.field_lng)
      }
    }

    this.mapList[key] = mapData
    this.fieldList[key] = fieldData
  }

  /* ポリゴン表示 */
  private mapCreate () {
    if (this.mapList.length !== 0) {
      /* リストの一番上のデータをマップの中心にする */
      if (Session.getChoiceFieldId()! === null) {
        if (this.mapList[0].path !== undefined && Object.keys(this.mapList[0].path).length !== 0) {
          if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
          }
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      } else {
        if (this.mapList[0].path !== undefined || this.mapData[0].path.length !== 0) {
          this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      }
    }
  }

  /* 詳細データ取得 */
  private getFieldDetailsData (id: number, idFlag: boolean) : any {
    (async () => {
      if (id !== 0 && id !== undefined) {
        /*
         * sessionStorageにデータがない場合、
         * もしくは検索、リセット、アコーディオンの変更時はAPIを叩く
         */
        if ((Session.getFieldDetailsData(String(id))! === null) || this.changeListData || this.target !== Session.getChoiceGrouping()) {
          let searchItem = {
            accordion: this.target,
            refile: this.$store.state.fieldState.plantingOnly,
            stage: '',
            variety: '',
            risk: 0,
            word: ''
          }

          const result = await FieldDetailsApi.getFieldDetailsData(String(id), idFlag, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])
          if (result.isOk()) {
            if (result.getPayload() === null) {
              return
            }

            this.fieldDetailsData.push(result.getPayload().field_detail_list)
            result.getPayload().field_detail_list.unshift({ timestamp: Date.now() })

            Session.setFieldDetailsData(JSON.stringify(result.getPayload().field_detail_list), String(id))
            // 保存したグルーピングの情報を保持
            Session.setChoiceGrouping(this.target)

            /* データ取得フラグ */
            this.$store.commit('setFlagState/setFieldDetailsDataFlag', true)

            let fieldList: any = this.$refs.fieldList
            if (fieldList !== undefined) {
              for (var i in fieldList) {
                if (fieldList[i].id === id) {
                  fieldList[i].showLoading = false
                }
              }
            }
          } else {
            const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
          }

          // 並び替え用にデータをセット
          let changeId = ''
          for (let i in this.fieldList) {
            changeId = String(id)
            if (parseInt(this.fieldList[i].accordionId) === id) {
              let data: any = this.fieldDetailsData
              for (let j in data) {
                for (let k in data[j]) {
                  if (this.fieldList[i].plantingId === data[j][k].planting_id) {
                    this.fieldList[i].intergration_temperature = data[j][k].intergration_temperature
                    this.fieldList[i].harvest_limit_date = data[j][k].harvest_limit_date
                  }
                }
              }
            }
          }
          this.count.push(id)
          // アコーディオン数の分データセットしたら並び替えする（作付けなしはデータセット不要）
          let accordionLength = this.accordionData.length
          for (let l in this.accordionData) {
            if (this.accordionData[l].accordion_id === 0) {
              accordionLength = this.accordionData.length - 1
            }
          }
          if (this.count.length === accordionLength) {
            this.changeSort()
          }
        } else {
          let fieldList = await this.fieldList
          // 並び替え用にデータをセット
          let changeId = ''
          let detail = Session.getFieldDetailsData(String(id))!
          let data: any = JSON.parse(detail)
          for (let i in fieldList) {
            changeId = String(id)
            if (parseInt(fieldList[i].accordionId) === id) {
              for (let j in data) {
                if (fieldList[i].plantingId === data[j].planting_id) {
                  fieldList[i].intergration_temperature = data[j].intergration_temperature
                  fieldList[i].harvest_limit_date = data[j].harvest_limit_date
                }
              }
            }
          }
          this.count.push(id)
          // アコーディオン数の分データセットしたら並び替えする（作付けなしはデータセット不要）
          let accordionLength = this.accordionData.length
          for (let l in this.accordionData) {
            if (this.accordionData[l].accordion_id === 0) {
              accordionLength = this.accordionData.length - 1
            }
          }
          if (this.count.length === accordionLength) {
            fieldList = this.fieldList
            this.changeSort()
          }
          /* データ取得フラグ */
          this.$store.commit('setFlagState/setFieldDetailsDataFlag', true)
        }
      } else {
        this.changeSort()
      }
    })()
  }

  private changeSort () {
    const area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    if (this.sortOrder === 'fieldName') {
      if (this.sort === 'asc') {
        this.fieldList.sort(
          function (a: any, b: any) {
            return (a.fieldName < b.fieldName ? -1 : 1)
          }
        )
      } else {
        this.fieldList.sort(
          function (a: any, b: any) {
            return (a.fieldName < b.fieldName ? 1 : -1)
          }
        )
      }
    } else if (this.sortOrder === 'harvestForecastDays') {
      if (this.sort === 'asc') {
        this.fieldList.sort(
          function (a: any, b: any) {
            // 収穫適期の残日数が無かったら0を代入
            if (a.harvest_limit_date === undefined) {
              a.harvest_limit_date = 0
            }
            if (b.harvest_limit_date === undefined) {
              b.harvest_limit_date = 0
            }

            return (a.harvest_limit_date < b.harvest_limit_date ? -1 : 1)
          }
        )
      } else {
        this.fieldList.sort(
          function (a: any, b: any) {
            // 収穫適期の残日数が無かったら0を代入
            if (a.harvest_limit_date === undefined) {
              a.harvest_limit_date = 0
            }
            if (b.harvest_limit_date === undefined) {
              b.harvest_limit_date = 0
            }

            return (a.harvest_limit_date < b.harvest_limit_date ? 1 : -1)
          }
        )
      }
    } else {
      if (this.sort === 'asc') {
        this.fieldList.sort(
          function (a: any, b: any) {
            // 積算温度が無かったら0を代入
            if (a.intergration_temperature === undefined) {
              a.intergration_temperature = 0
            }
            if (b.intergration_temperature === undefined) {
              b.intergration_temperature = 0
            }

            return (a.intergration_temperature < b.intergration_temperature ? -1 : 1)
          }
        )
      } else {
        this.fieldList.sort(
          function (a: any, b: any) {
            // 積算温度が無かったら0を代入
            if (a.intergration_temperature === undefined) {
              a.intergration_temperature = 0
            }
            if (b.intergration_temperature === undefined) {
              b.intergration_temperature = 0
            }

            return (a.intergration_temperature < b.intergration_temperature ? 1 : -1)
          }
        )
      }
    }

    this.displayAccordionData = this.accordionData
    this.displayFieldList = this.fieldList
    if (this.changeListData === true) {
      this.changeListData = false
    }
    this.showFieldListLoading = false
  }

  /* 検索 */
  /*
   * openFlag=trueは画面遷移、ブラウザバッグの場合(検索状態保持のためアコーディオン開く)
   * openFlag=falseは検索ボタン押下時(アコーディオンを閉じる)
   */
  private async doSearch (openFlag: boolean) {
    this.showFieldListLoading = true
    this.changeListData = true
    let search: any = this.$refs.search
    this.renderList = false
    if (search !== undefined) {
      search.requesting = true
    }

    this.isActive = true
    const area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    const searchItem = {
      accordion: this.target,
      refile: this.$store.state.fieldState.plantingOnly,
      status: this.$store.state.fieldState.fieldSearchStatus,
      variety: this.$store.state.fieldState.fieldSearchVariety,
      risk: this.$store.state.fieldState.fieldSearchRisk,
      word: this.$store.state.fieldState.fieldSearchText,
      target: this.$store.state.fieldState.accordionType
    }
    const result = await FieldSortApi.doFieldSort(fieldDetailsApiFlag.FLAG_FIELD_TARGET, searchItem, [])

    if (result.isOk()) {
      /* マップのデータを作成 */
      /* 圃場件数 */
      this.totalFieldCount = result.getPayload().total_field_count

      /* データ追加フラグ更新 */
      this.$store.commit('setFlagState/setSelectDataListFlag', true)
      this.$store.commit('setFlagState/setMySelectDataListFlag', true)

      /* マップのデータを作成 */
      if (result.getPayload().polygon_list.length !== 0) {
        // 作付けなしを一番下に配置
        const sortAccodionList = result.getPayload().accordion_list
        const index = sortAccodionList.findIndex((n: any) => n.accordion_name === '')
        if (index !== -1) {
          const x: any = sortAccodionList.splice(index, 1)
          sortAccodionList.push(x[0])
        }
        this.accordionData = sortAccodionList
        this.accordionList = sortAccodionList

        /* アコーディオンを一度すべて閉じる */
        for (var i in this.accordionList) {
          let id = this.accordionList[i].accordion_id
          this.$set(this.isOpend, id, false)

          if (!openFlag) {
            this.accordionFlag = false
          }
        }

        // 選択している圃場のリセット
        this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
        this.$router.push('/field').catch(e => {})

        // リセット
        this.mapList = Array(result.getPayload().polygon_list.length)
        this.fieldList = Array(result.getPayload().polygon_list.length)

        // データ取得できたら描画
        this.renderList = true

        /* エリアごとに詳細を取得 */
        this.count = []
        for (var k in result.getPayload().accordion_list) {
          let accordionData = result.getPayload().accordion_list[k]
          this.getFieldDetailsData(accordionData.accordion_id, true)
        }

        /* マップデータ作成 */
        for (var j in result.getPayload().polygon_list) {
          this.createDataList(result.getPayload().polygon_list[j], parseInt(j))

          /* エリアデータをlocalstorageに保存 */
          let accordionData = result.getPayload().polygon_list[j]
          accordionData['timestamp'] = Date.now()
        }

        this.showNotFound = false
      } else {
        this.accordionData = []
        this.displayAccordionData = []
        this.accordionList = []

        this.mapList = []
        this.fieldList = []
        this.displayFieldList = []
        this.showNotFound = true
        this.showFieldListLoading = false
      }
      this.mapCreate()
      this.isActive = false

      if (search !== undefined) {
        search.requesting = false
      }
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      this.showFieldListLoading = false
    }
  }

  /* リセット */
  private resetFieldList () {
    if (this.showNotFound) {
      this.showNotFound = false
    }

    this.showFieldListLoading = true
    this.changeListData = true

    this.target = '1'
    this.$store.commit('fieldState/setAccordionType', this.target)

    // 選択している圃場のリセット
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
    this.$router.push('/field').catch(e => {})

    this.accordionData = []
    this.displayAccordionData = []
    this.fieldList = []
    this.displayFieldList = []
    this.sortOrder = 'harvestForecastDays'
    this.sort = 'asc'
    this.$store.commit('fieldState/setSortOrder', this.sortOrder)
    this.$store.commit('fieldState/setSort', this.sort)
    this.getFieldData(true)
  }

  /* アコーディオンのターゲット変更 */
  private async changeTarget () {
    this.showFieldListLoading = true
    this.accordionData = []
    this.displayAccordionData = []
    this.fieldList = []
    this.displayFieldList = []
    this.$store.commit('fieldState/setAccordionType', this.target)
    this.renderList = false

    // 選択している圃場のリセット
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
    this.$router.push('/field').catch(e => {})

    const searchItem = {
      accordion: this.target,
      refile: this.$store.state.fieldState.plantingOnly,
      status: this.$store.state.fieldState.fieldSearchStatus,
      variety: this.$store.state.fieldState.fieldSearchVariety,
      risk: this.$store.state.fieldState.fieldSearchRisk,
      word: this.$store.state.fieldState.fieldSearchText,
      target: this.$store.state.fieldState.accordionType
    }
    const result = await FieldSortApi.doFieldSort(fieldDetailsApiFlag.FLAG_FIELD_TARGET, searchItem, [])

    if (result.isOk()) {
      /* マップのデータを作成 */
      /* 圃場件数 */
      this.totalFieldCount = result.getPayload().total_field_count

      /* データ追加フラグ更新 */
      this.$store.commit('setFlagState/setSelectDataListFlag', true)
      this.$store.commit('setFlagState/setMySelectDataListFlag', true)

      /* マップのデータを作成 */
      if (result.getPayload().polygon_list.length !== 0) {
        // 作付けなしを一番下に配置
        const sortAccodionList = result.getPayload().accordion_list
        const index = sortAccodionList.findIndex((n: any) => n.accordion_name === '')
        if (index !== -1) {
          const x: any = sortAccodionList.splice(index, 1)
          sortAccodionList.push(x[0])
        }
        this.accordionData = sortAccodionList
        this.accordionList = sortAccodionList

        /* アコーディオンを一度すべて閉じる */
        for (var i in this.accordionList) {
          let id = this.accordionList[i].accordion_id
          this.$set(this.isOpend, id, false)
          this.accordionFlag = false
        }

        // リセット
        this.mapList = Array(result.getPayload().polygon_list.length)
        this.fieldList = Array(result.getPayload().polygon_list.length)

        // データ取得できたら描画
        this.renderList = true

        /* エリアごとに詳細を取得 */
        this.count = []
        for (var k in result.getPayload().accordion_list) {
          let accordionData = result.getPayload().accordion_list[k]
          this.getFieldDetailsData(accordionData.accordion_id, true)
        }

        /* マップデータ作成 */
        for (var j in result.getPayload().polygon_list) {
          this.createDataList(result.getPayload().polygon_list[j], parseInt(j))

          /* エリアデータをlocalstorageに保存 */
          let accordionData = result.getPayload().polygon_list[j]
          accordionData['timestamp'] = Date.now()
        }

        this.showNotFound = false
      } else {
        this.accordionData = []
        this.displayAccordionData = []
        this.accordionList = []

        this.mapList = []
        this.fieldList = []
        this.displayFieldList = []
        this.showNotFound = true
        this.showFieldListLoading = false
      }

      this.isActive = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      this.showFieldListLoading = false
    }
  }

  /* アコーディオン */
  private isOpenedAccordion (key: number) {
    if (this.accordionChangeFlag) {
      this.accordionChangeFlag = false
    } else {
      this.accordionChangeFlag = true
    }
    this.accordionOpenFlag = false
    this.$set(this.isOpend, key, !this.isOpend[key])
  }

  private openSpecificAccordion (areaId: string) {
    if (this.accordionChangeFlag) {
      this.accordionChangeFlag = false
    } else {
      this.accordionChangeFlag = true
    }
    // emitされてきたopen
    this.accordionOpenFlag = true
    let key = parseInt(areaId)
    this.$set(this.isOpend, key, true)
  }

  private afterTransition () {
    let id = Session.getChoiceFieldId()
    let el: any = document.getElementById(String(id))

    // クリックでアコーディオンを開くときはscrollしない
    if (el && this.accordionOpenFlag) {
      el.scrollIntoView({ behavior: 'instant' })
    }

    this.accordionOpenFlag = true
  }
}
